// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__MC3t8","paramInput":"JobSimulator_paramInput__3pSJS","input":"JobSimulator_input__1D8o2"};